import { BoxProps } from '@mui/material';

import * as Styled from './styles';

const SearchBar: React.FC<BoxProps> = ({ children, ...props }) => (
  <Styled.SearchBarContainer {...props}>{children}</Styled.SearchBarContainer>
);

export default SearchBar;
